export const speed = {
    input: '.10s',
    content: '.20s'
};

export const canvasAnimationSpeed = {
    slow: 0.01,
    fast: 0.1,
};
